import React from 'react';
import { Grid, Row } from 'react-flexbox-grid';

import ContentWrapper from 'components/ContentWrapper';
import SummaryLoader from 'containers/SummaryLoader';
import { wrapper } from './Summary.less';

import Background from '../Background';
import Lifestyle from '../Lifestyle';
import Relapse from '../Relapse';
import Status from '../Status';
import QualityOfLife from '../QualityOfLife';
import Scores from '../Scores';
import Medication from '../Medication';
import Comorbidity from '../Comorbidity';
import Benefits from '../Benefits';
import Rehabilitation from '../Rehabilitation';
// import Floodlight from '../Floodlight';
import OnlineRehabilitation from '../OnlineRehabilitation';

const Summary = () => (
  <SummaryLoader>
    <ContentWrapper>
      <div className={wrapper}>
        <Grid fluid>
          <Row>
            <Background />
            <Lifestyle />
            <Relapse />
            <Status />
            <QualityOfLife />
            <Medication />
            <Benefits />
            <Rehabilitation />
            <Scores />
            <Comorbidity />
            {/* <Floodlight /> */}
            <OnlineRehabilitation />
          </Row>
        </Grid>
      </div>
    </ContentWrapper>
  </SummaryLoader>
);

export default Summary;
